import { lazy } from 'react';

const NotFound = lazy(() =>  import('../pages/General/NotFound'));
const DashboardPage = lazy(() =>  import('../pages/General/Dashboard'));
const DocumentsPage = lazy(() =>  import('../pages/General/Documents'));
const ReportsPage = lazy(() =>  import('../pages/General/Reports'));

const general = [{
    path: '/',
    element: DashboardPage,
    exact: true,
    analytics: { name: ["Dashboard"] },
},{
    path: '/documents',
    element: DocumentsPage,
    exact: true,
    analytics: { name: ["Documenti"] },
},{
    path: '/reports',
    element: ReportsPage,
    exact: true,
    analytics: { name: ["Report"] },
},{
    path: "*",
    element: NotFound,
    analytics: { name: ["404"]},
},{
    path: "/404",
    element: NotFound,
    analytics: { name: ["404"]},
}]

export default general;